import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Calendar } from "lucide-react";
import { getAnnouncements } from "@/api/announcements";
import { SEO } from "@/components/site/SEO";

export function AnnouncementsPage() {
  const { lang, t } = useLang();
  const [list, setList] = useState<any[]>([]);
  useEffect(() => {
    getAnnouncements(true)
      .then(data => setList(data ?? []))
      .catch(err => console.error('Failed to load announcements:', err));
  }, []);
  return (
    <div className="container mx-auto px-4 py-16">
      <SEO
        title={t("section.announcements")}
        description={
          lang === "tr"
            ? "Awork Danışmanlık güncel duyuruları, şirket haberleri ve sektörel gelişmeler."
            : "Awork Consulting latest announcements, company news, and industry updates."
        }
      />
      <h1 className="text-4xl font-bold text-primary mb-2 text-center">{t("section.announcements")}</h1>
      <div className="w-20 h-1 bg-primary mx-auto mb-12 rounded-full" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {list.map(a => {
          const pubDate = a.created_at ? new Date(a.created_at) : new Date();
          const title = lang === "tr" ? a.title_tr : a.title_en;
          const content = lang === "tr" ? a.content_tr : a.content_en;
          return (
            <Link key={a.id} to={`/announcements/${a.id}`} className="group">
              <article className="bg-card border overflow-hidden hover:shadow-md transition-shadow flex flex-col h-full group-hover:border-primary/50">
                <div className="h-90 aspect-square bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center shrink-0">
                  {a.image_url ? (
                    <img
                      src={a.image_url}
                      alt={title || "Duyuru görseli"}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <Calendar size={56} className="text-white/90" />
                  )}
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
                    <Calendar size={14} />{pubDate.toLocaleDateString(lang === "tr" ? "tr-TR" : "en-US")}
                  </div>
                  <h2 className="text-xl font-bold text-primary mb-2 group-hover:text-primary/80 transition-colors flex-1">{title}</h2>
                </div>
              </article>
            </Link>
          );
        })}
        {list.length === 0 && <p className="text-center text-muted-foreground col-span-full">—</p>}
      </div>
    </div>
  );
}
